// Service worker registration with automatic activation after deploys.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost'
    || window.location.hostname === '[::1]'
    || window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

let refreshing = false;

function promptWaitingWorkerToActivate(worker) {
  if (!worker) return;
  worker.postMessage({ type: 'SKIP_WAITING' });
}

function listenForControllerChange() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

function scheduleUpdateChecks(registration) {
  const runUpdate = () => {
    registration.update().catch(() => {});
  };

  window.setInterval(runUpdate, 60 * 60 * 1000);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      runUpdate();
    }
  });
}

export function register(config) {
  const enableDevPwa =
    process.env.REACT_APP_ENABLE_PWA === 'true'
    || (process.env.NODE_ENV !== 'production' && isLocalhost);
  if (process.env.NODE_ENV !== 'production' && !enableDevPwa) return;
  if (!('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  listenForControllerChange();

  window.addEventListener('load', () => {
    const swUrl = process.env.NODE_ENV === 'production'
      ? `${process.env.PUBLIC_URL}/service-worker.js`
      : `${process.env.PUBLIC_URL}/pwa-dev-sw.js`;

    const onUpdate = (registration) => {
      if (registration.waiting) {
        promptWaitingWorkerToActivate(registration.waiting);
      }
      config?.onUpdate?.(registration);
    };

    const onSuccess = (registration) => {
      scheduleUpdateChecks(registration);
      config?.onSuccess?.(registration);
    };

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, { ...config, onUpdate, onSuccess });
    } else {
      registerValidSW(swUrl, { ...config, onUpdate, onSuccess });
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (registration.waiting && navigator.serviceWorker.controller) {
        promptWaitingWorkerToActivate(registration.waiting);
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            promptWaitingWorkerToActivate(installingWorker);
            config?.onUpdate?.(registration);
          } else {
            config?.onSuccess?.(registration);
          }
        };
      };

      if (navigator.serviceWorker.controller) {
        scheduleUpdateChecks(registration);
      }
    })
    .catch(() => {
      // registration failed; app still works online
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404
        || (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      // Offline or SW URL unreachable (dev); ignore
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
